import React, { useState, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import moment from "moment";
import Input from "./Input";

function CarePlanComments({
  isOpen,
  comments,
  carePlanIndex,
  handleChange,
  handleSave,
  handleClose,
}) {
  const [commentsArray, setCommentsArray] = useState(comments);

  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const userInfo = useMemo(() => {
    return safyInfo?.user;
  }, [safyInfo]);

  const userDomainName = useMemo(() => {
    return userInfo?.domainName.replace("safy\\", "");
  }, [userInfo]);

  const handleSaveRow = (index) => {
    const comms = [...commentsArray];

    if (comms[index].Message?.length > 25000) {
      toast.error(
        `Character limit exceeded: ${comms[index].Message.length}/25000`
      );
      return;
    }

    delete comms[index].IsEditable;
    setCommentsArray(comms);
    handleChange(comms, carePlanIndex);
  };

  const handleDeleteRow = (index) => {
    const comms = [...commentsArray];
    comms.splice(index, 1);
    setCommentsArray(comms);
    handleChange(comms, carePlanIndex);
  };

  const handleEditRow = (index) => {
    const comms = [...commentsArray];
    comms[index].IsEditable = true;
    setCommentsArray(comms);
  };

  const handleAddRow = () => {
    const comms = [...commentsArray];
    comms.push({
      CreatedBy: safyInfo.user.domainName.replace("safy\\", ""),
      CreatedOn: new Date(),
      IsEditable: true,
    });
    setCommentsArray(comms);
  };

  const handleRowChange = ({ currentTarget: input }, index) => {
    const comms = [...commentsArray];
    comms[index][input.name] = input.value;
    setCommentsArray(comms);
  };

  return isOpen ? (
    <Modal className="rounded" show={isOpen} animation={false} size="xl">
      <Modal.Header className="bg-safy3-1">
        <Modal.Title>Care Plan Comments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container border-start border-top">
          <div className="row border-bottom">
            <div className="col-4 border-end py-2">Created By - On</div>
            <div className="col border-end py-2">Comment</div>
          </div>
          {commentsArray.map((comment, index) => (
            <div className="row border-bottom" key={`Comment.${index}`}>
              <div className="col-4 border-end py-2 d-flex">
                {comment.IsEditable ? (
                  <>
                    <i
                      className="fas fa-save me-2 d-print-none"
                      onClick={() => {
                        handleSaveRow(index);
                      }}
                    ></i>
                    <i
                      className="far fa-trash-alt me-2 d-print-none"
                      onClick={() => {
                        handleDeleteRow(index);
                      }}
                    ></i>
                  </>
                ) : comment.CreatedBy === userDomainName ? (
                  <i
                    className="fas fa-pen me-2 d-print-none"
                    onClick={() => {
                      handleEditRow(index);
                    }}
                  ></i>
                ) : null}
                {comment.CreatedBy} - {moment(comment.CreatedOn).format("l LT")}
              </div>
              <div className="col border-end py-2">
                {comment.IsEditable ? (
                  <Input
                    name="Message"
                    value={comment.Message}
                    onChange={(e) => {
                      handleRowChange(e, index);
                    }}
                    maxCharacters={25000}
                  />
                ) : (
                  comment.Message
                )}
              </div>
            </div>
          ))}
        </div>
        <button
          className="btn btn-primary mt-2"
          onClick={() => {
            if (!safyInfo?.user?.domainName) {
              console.log("safyInfoBroke", safyInfo);
              return;
            }

            handleAddRow();
          }}
        >
          Add Comment
        </button>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger float-end" onClick={handleClose}>
          Close
        </button>
        <button
          className="btn btn-primary float-end"
          onClick={() => {
            handleSave(commentsArray);
          }}
        >
          Save and Close
        </button>
      </Modal.Footer>
    </Modal>
  ) : null;
}

export default CarePlanComments;
